import API from "./api"
import {eventpartners } from "./endpoints"


export const getAllEventPartners = ()=>{
    return API.get(`${eventpartners}`)
}